// extracted by mini-css-extract-plugin
export default {"Card":"ViewerCard_Card__aFn2p","CopyButton":"ViewerCard_CopyButton__Mk-GN"};